import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1154.97643,0 L988.342187,166.519325 C927.894178,226.967335 924.906253,319.937752 972.942884,387.166051 L670.358078,689.750857 C666.335872,693.773063 663.807628,698.71463 661.279385,703.541277 C514.066648,642.518667 332.6077,669.295067 216.653249,785.249517 L118.626345,883.391342 L536.935761,1301.58584 L16.8070748,1821.71453 C-5.60235826,1844.12396 -5.60235826,1880.43873 16.8070748,1902.96308 C28.0692514,1914.11034 42.7790331,1919.74143 57.4888147,1919.74143 C72.1985964,1919.74143 86.9083781,1914.11034 98.0556345,1902.96308 L618.184321,1382.8344 L1036.37882,1801.14381 L1134.52064,1703.00199 C1210.48287,1627.15468 1252.31382,1526.13985 1252.31382,1418.68949 C1252.31382,1362.49353 1240.2472,1308.48105 1218.52729,1258.49077 C1221.28537,1256.65205 1224.38821,1255.50285 1226.80154,1252.97461 L1530.76539,949.010759 C1559.95511,970.15607 1594.661,982.107768 1631.43545,982.107768 C1677.51844,982.107768 1720.72843,964.180221 1753.36575,931.542893 L1920,764.908647 L1154.97643,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPinSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconPinSolid, _Component);

  var _super = _createSuper(IconPinSolid);

  function IconPinSolid() {
    _classCallCheck(this, IconPinSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconPinSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPin",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPinSolid.displayName = "IconPinSolid";
  return IconPinSolid;
}(Component);

IconPinSolid.glyphName = 'pin';
IconPinSolid.variant = 'Solid';
IconPinSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPinSolid;
export { IconPinSolid };